import './NoResultsPage.css';
import IconObject from '../../../../../assets/svgs/circle-object.svg';
import { Button } from '../../../../../ds-components';

const NoResultsPage = ({ filtersProps }) => {
  // const synonyms = filtersProps.synonyms;
  // const query = useSelector((state) => state.searchTributario.query);

  return (
    <div className="no-results-wrapper">
      <div className="no-results-container">
        <img src={IconObject} alt="" className="icon-object" />

        <h2>Esta busca não obteve resultados</h2>
        <p>
          Tente modificar os filtros ou refazer a<br />
          busca com termos mais amplos!
        </p>

        <div className="container-button-noresults-page">
          <a href="https://wa.me/+5511942612502" target="_blank">
            <Button
              icon={
                <img
                  className={'icon-button-img'}
                  src="/icon-button.png"
                  alt=""
                />
              }
              appearance={'blue900'}
              className="help-button"
            >
              Quero ajuda
            </Button>
          </a>

          {/* {!synonyms && (
            <div className="similar-button-wrapper">
              <button
                className="similar-button"
                onClick={() => {
                  filtersProps?.changeSynonyms(true);
                  filtersProps?.saveFilters?.(
                    filtersProps.history,
                    filtersProps.match,
                    encodeURIComponent(query),
                  );
                }}
              >
                + Buscar por termos semelhantes
              </button>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default NoResultsPage;
